import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { TProps } from './types/TProps';

export const PaymentMethod = ({ isLoading, defaultPaymentMethod }: TProps) => {
  const { openModal } = useModalContext();
  const { organization } = useAuthContext();

  const addNewPaymentMethod = () => {
    openModal(ModalNamesEnum.AddPaymentMethod, {
      onSuccess: () => {
        openModal(ModalNamesEnum.TopUpCreditBalance);
      },
    });
  };

  if (isLoading || !organization?.billingAccount) {
    return <div className="card empty">Loading...</div>;
  }
  if (!defaultPaymentMethod) {
    return (
      <div className="flex justify-between items-center">
        <div className="card empty red w-1/2">Not set</div>
        <div className="w-1/3">
          <OutlinedButton onClick={addNewPaymentMethod} type="button">
            Add a payment method
          </OutlinedButton>
        </div>
      </div>
    );
  }
  return <div className="card">Card: **** {defaultPaymentMethod.last4}</div>;
};
